import {
  IRVM_AUTRES_CAPITAUX,
  IRVM_BONS_CAISSE_BANQUES,
  IRVM_DIVIDENDES,
  IRVM_OBLIGATIONS,
} from '@shared/constants/Taux';
import { roundFCFA } from '@shared/utils/round';

export interface IRVMResult {
  montant_brut: number;
  taux: number;
  irvm: number;
  net: number;
}

/** Nature du revenu de capitaux mobiliers (CGI art. 109-110, page DGI « IRCM »). */
export type TypeRevenuCapitaux =
  | 'dividendes'
  | 'obligations'
  | 'bons_caisse_banques'
  | 'autres_capitaux';

/**
 * IRCM (ancien nom : IRVM) — prélèvement libératoire de l'IRPP sur les revenus de capitaux mobiliers.
 * Sources : https://dgi.ga/imposition-des-personnes-morales/ircm/ et CGI art. 109-110 :
 *  - dividendes et revenus assimilés, créances, dépôts : 20 % ;
 *  - obligations à échéance d'au moins 5 ans émises au Gabon : 10 % ;
 *  - bons de caisse émis par les banques : 15 %.
 * Non couverts : régime des sociétés cotées à la BVMAC (CGI art. 63), régime mère-filiale (art. 116, 10 %).
 */
export class IRVMService {
  static taux(type: TypeRevenuCapitaux): number {
    switch (type) {
      case 'obligations':
        return IRVM_OBLIGATIONS;
      case 'bons_caisse_banques':
        return IRVM_BONS_CAISSE_BANQUES;
      case 'autres_capitaux':
        return IRVM_AUTRES_CAPITAUX;
      default:
        return IRVM_DIVIDENDES;
    }
  }

  static calculer(montant_distribue: number, type: TypeRevenuCapitaux = 'dividendes'): IRVMResult {
    const taux = this.taux(type);
    const irvm = roundFCFA(montant_distribue * taux);
    return {
      montant_brut: montant_distribue,
      taux,
      irvm,
      net: roundFCFA(montant_distribue - irvm),
    };
  }
}
